import styled from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

export const SwitchLinkWrapper = styled.div`
    margin-top: 10px;
    font-size: 0.75em;
    line-height: 1.4;
    letter-spacing: 0.0125em;
    text-align: center;
    color: inherit;

    ${fromBreakpoint[TABLET]`
        margin-top: 20px;
    `}
`;
